import { Table, Text } from "@mantine/core";
import { HeldEmailListItem } from "../../../services/admin/systemEmails.service";
import { HeldEmailRecipientCells } from "./HeldEmailRecipientCells";

interface HeldEmailQueueIdentityCellsProps {
  email: HeldEmailListItem;
}

export function HeldEmailQueueIdentityCells({
  email,
}: HeldEmailQueueIdentityCellsProps) {
  return (
    <>
      <Table.Td>
        <Text fw={600} size="sm">
          {email.emailTypeLabel}
        </Text>
        <Text c="dimmed" size="xs">
          {email.subject}
        </Text>
      </Table.Td>
      <HeldEmailRecipientCells email={email} />
    </>
  );
}
